<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <dashboard-management />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import DashboardManagement from "./DashboardManagement";
    export default {
        name: "Dashboard",
        components: {DashboardManagement}
    }
</script>

<style scoped>

</style>

